import Breadcrumb from '../../Component/breadcrumb/Breadcrumb';
import '../Pages/about/style/Aaboutus.css';
function LoyaltyTerms() {

   return(
      <>
       <Breadcrumb/>
       <div className="Aboutus"> 
                <div className="container" style={{ border: "1px solid #cac3c3" }}> 
                 <div className="row" style={{ background: "#dcdbdb", padding: "15px 20px" }}> 
                            <div className="col-md-12"> 
                                <h3 className="text-center text-sm"> LOYALTY POINTS PROGRAM REWARD SCHEME TERMS AND CONDITIONS </h3>
                                <hr/>
                                <p className="text-center"> Effective From "15 - 09 - 2018" </p>
                           </div>
                    </div>  

                   <div className="row mt-3">
                        <div className="col-md-1 first1">1</div>
                        <div className="col-md-11 first2">Introduction </div>
                    </div>
	 
                    <div className="row">
                        <div className="col-md-1 second1">1.1</div>
                        <div className="col-md-11 second2">These Terms and Conditions:</div>
                    </div>
	 
                    <div className="row">
                        <div className="col-md-1 third1">(a)</div>
                        <div className="col-md-11 third2">
                            Apply to and govern the contractual relationship between the Program Partner and each Distributors with respect to the Reward Scheme made available by the Program Partner as a participant in the
                            <b>Club Obsessions Rewards Points</b> herein after read as "CORP";
                        </div>
                    </div>
	 
                    <div className="row">
                        <div className="col-md-1 third1">(b)</div>
                        <div className="col-md-11 third2">Are effective from the date specified above and may be amended from time to time.</div>
                    </div>
	 
                    <div className="row">
                        <div className="col-md-1 third1">(c)</div>
                        <div className="col-md-11 third2">
                            Operate in conjunction with the "CORP" Terms and Conditions(available at <a href="http://b2b.obsessions.co.in/"><u>b2b.obsessions.co.in </u></a>) &nbsp; and in the event of any inconsistency or conflict
                            the CORP" Terms and Conditions prevail.
                        </div>
                    </div>
	 
                    <div className="row">
                        <div className="col-md-12 second1">1.2</div>
                        <div className="col-md-11 second2">
                            The current Reward Scheme Terms and Conditions are available here. It is the Distributor's responsibility to read and understand them. Any queries regarding these Terms and Conditions should be directed to the
                            Program Partner.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">2</div>
                        <div className="col-md-11 first2"> Definitions</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">2.1</div>
                        <div className="col-md-11 second2">Unless the context other wise requires.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(a)</div>
                        <div className="col-md-11 third2">Terms used in the "CORP" Terms and Conditions and the Program Terms have the same meaning in these Terms and Conditions; and</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(b)</div>
                        <div className="col-md-11 third2">The following terms have these meanings in these Terms and Conditions.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1"></div>
                        <div className="col-md-11 second2">Eligible Products means all type of "Home &amp; Bath Accessories except carpets" provided by 'Obsessions'.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1"></div>
                        <div className="col-md-11 second2">
                            Program Partner means Club Obsessions Reward Points here in after read as "CORP" is a coalition loyalty marketing program owned and operated by Envogue Furnishings (India) Pvt. Ltd.
                            (hereafter referred to as "Club Obsessions"), Brand Name: Obsessions, Basement, 20 Pusa Road, Karol Bagh, New Delhi-110005.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1"></div>
                        <div className="col-md-11 second2">Distributors means channel partners to sell the products. Home Accessories of Program Partner under brand "Obsessions" in their territory.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1"></div>
                        <div className="col-md-11 second2">
                            Loyalty Points Program Reward Scheme means Club Obsessions Reward Points allows members to earn Reward Points through the purchase of their entire products range of Home &amp; Bath Accessories except carpets
                            and redeem Reward Points for credit notes.
                        </div>
                    </div>

                    <div className="row mb">
                        <div className="col-md-1 second1"></div>
                        <div className="col-md-11 second2">Terms and Conditions means these Reward Scheme Terms and Conditions which are administered by the Program Partner.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">2.2</div>
                        <div className="col-md-11 second2">In these Terms and Conditions, unless the contrary intention appears:</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(a)</div>
                        <div className="col-md-11 third2">The singular includes the plural and vice versa; and</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(b)</div>
                        <div className="col-md-11 third2">A reference to 'include' or 'including' means including but not limited to.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">3</div>
                        <div className="col-md-11 first2">Application of Reward Scheme Terms and Conditions.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">3.1</div>
                        <div className="col-md-11 second2">
                            By claiming any "CORP" Rewards Benefit under the Reward Scheme, a Member agrees to be bound by these Terms and Conditions in addition to the "CORP" Terms and Conditions and you acknowledge
                            that Club Obsessions assumes no contractual or legal responsibility to you and specifically limited its legal obligations in its arrangements with the partners to whom rewards are supplied.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">3.2</div>
                        <div className="col-md-11 second2">
                            Club Obsessions will be the final authority as to whether any member qualifies under the Terms and Conditions of the Club Obsessions Program.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">4</div>
                        <div className="col-md-11 first2">Changes to Reward Scheme</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">4.1</div>
                        <div className="col-md-11 second2">
                            Subject to clause 4.2 and the Reward Scheme Terms and Conditions, the Program Partner may implement any changes (whether material or otherwise) to these Terms and Conditions and the Points offered in relation to
                            Eligible Products, including changes to:
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(a)</div>
                        <div className="col-md-11 third2">The ways in which "CORP" are earned under the Reward Scheme.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(b)</div>
                        <div className="col-md-11 third2">Eligible Products; and</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 third1">(c)</div>
                        <div className="col-md-11 third2">Restrictions, conditions and eligibility to earn Points under the Reward Scheme.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">4.2</div>
                        <div className="col-md-11 second2">
                            The Program Partner will inform Members of changes to these Terms and Conditions and where such changes will reduce the number of "CORP" offered to Members under the Reward Scheme, when possible, give
                            Members at least 30 days' notice.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">4.3</div>
                        <div className="col-md-11 second2">
                            Without limiting clause 4.1 in any way, Members will be taken to have received the notice referred to in clause 4.2 if the Program Partner or "CORP" notifies Members of the change by sending an email to
                            the email address in the Membership Account.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">5</div>
                        <div className="col-md-11 first2">Termination or suspension of the Reward Scheme </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">5.1</div>
                        <div className="col-md-11 second2">
                            The Program Partner gives no undertaking as to the continuing availability of the Reward Scheme. The Program Partner may terminate or suspend the Reward Scheme at any time and will give at least 30 days notice to
                            distributors of such termination or suspension, except if the Club Obsessions Rewards Program ceases to operate, in which case the Reward Scheme will cease immediately.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">6</div>
                        <div className="col-md-11 first2">Earning Loyalty Points Program Rewards Benefits.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">6.1</div>
                        <div className="col-md-11 second2">
                            Subject to the exclusions, limitations and other conditions specified in this clause 6, the Program Partner will award "CORP" rewards Benefits to Distributors at the applicable rate specified in the
                            Program Partner Calculation Table.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">6.2</div>
                        <div className="col-md-11 second2">No Rewards Benefits will be awarded if the product is cancelled,refunded or returned except manufacturing defects and damage in the transit.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">6.3</div>
                        <div className="col-md-11 second2">
                            There are negative points system under the above scheme, if payment received after the credit period specified in the Table refer to 6.1 and Distributors have negative closing balance of loyalty points then
                            "CORP"will raise the debit note at the end of the financial year.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">6.4</div>
                        <div className="col-md-11 second2">
                            The Program Partner may offer additional opportunities to earn Points in "CORP" under a special promotion from time to time, in which case the terms and conditions referred to in the promotion will apply.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">6.5</div>
                        <div className="col-md-11 second2">
                            "CORP" have no monetary value whatsoever and cannot under any circumstances form the basis of a monetary claim against Club Obsessions and earned points are not transferrable.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">7</div>
                        <div className="col-md-11 first2">
                            Crediting &amp; Redemption of Earned Loyalty Points in the Scheme
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">7.1</div>
                        <div className="col-md-11 second2">
                            The Program Partner will endeavour to instruct "CORP" to credit the applicable number of Club Obsessions Reward Points to the Membership Account after realization of payment. It is the responsibility of
                            the Distributors to check that the correct number of loyalty Points has accumulated in the Membership Account. If any discrepancy found, can be entertained within 30 days from the date of remittance of payments
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">7.2</div>
                        <div className="col-md-11 second2">
                            Claims for the crediting of loyalty points in Loyalty Points Program Reward Scheme retrospectively must be made by Distributors to the Program Partner twice in a year only. Unless otherwise specified by
                            "CORP", claims for the crediting of the loyalty points cannot be made if the membership account was not active at the time of the eligible product was purchased.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">7.3</div>
                        <div className="col-md-11 second2">
                            Redemption for the credited Loyalty Points can be done twice in a year and system will automatically calculate the same as per Calculation Table. Redemption is available against the goods only on minimum
                            balance of 5000 points.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">7.4</div>
                        <div className="col-md-11 second2">
                            No waiver by either Club Obsessions or you of any breach or default here under shall be deemed to be a waiver of any preceding or subsequent breach or default. If any provisions contained here in shall be
                            determined to be void, invalid, or otherwise unenforceable by a court of Delhi Jurisdiction only, such termination shall not affect the remaining provisions contained here in.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">8</div>
                        <div className="col-md-11 first2">Suspension or termination of a Member or Loyalty Points in Reward Scheme.</div>
                    </div>
                    <div className="row">
                        <div className="col-md-1 second1">8.1</div>
                        <div className="col-md-11 second2">
                            The Program Partner reserves the right to terminate a Distributor's participation in the Reward Scheme or with hold or cancel loyalty points claimed under the Reward Scheme, if a Member or any of the Member's
                            representatives has attempted to claim loyalty Points under the Reward Scheme to which they were not entitled.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">8.2</div>
                        <div className="col-md-11 second2">
                            The Program Partner and "CORP" will not be liable for any loss or damage what so ever suffered by any person as a result of such withholding or cancellation and the Member is responsible for ensuring that
                            its nominated loyalty Points Recipients are notified of this.
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1">8.3</div>
                        <div className="col-md-11 second2">All disputes subject to Delhi Jurisdiction only.</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 first1">9</div>
                        <div className="col-md-11 first2">Taxation Implications</div>
                    </div>

                    <div className="row">
                        <div className="col-md-1 second1"></div>
                        <div className="col-md-11 second2">
                            The Program Partner recommends those Members and their nominated Loyalty Points Recipients consult their accountant or tax adviser to ensure that they understand possible tax implications, if any, related to
                            their earning and use of loyalty Points under the Reward Scheme.
                        </div>
                    </div>

                    <div className="row" style={{ backgroundColor: "rgb(212 209 209)", padding: "20px 0", marginTop:"20px" }}>
                           <div className="col-md-12">
                               <div style={{ paddingLeft:"10px" }}> 
                                    En'vogue Furnishings (India) Pvt. Ltd. (Club Obsessions)<br/>
                                    Basement, 20 Pusa Road,<br/>
                                    Karol Bagh, New Delhi-110005
                                </div>
                           </div>
                    </div>
                </div> 
               <div className="container">      
               <div class="row mt-4">
                        <div class="col-md-12 text-center">

                            <h3 class="col-md-12" style={{fontSize: "24px", textDecoration: "underline" }}>  Calculation Table </h3>

                            <table class="table table-bordered text-center">
                                <tbody>
                                    <tr align="center">
                                        <th style={{ fontWeight: "500" }}> <center>Minimum Payment Days</center> </th> 
                                        <th style={{ fontWeight: "500" }}> <center>Maximum Payment Days</center> </th>
                                        <th style={{ fontWeight: "500" }}> <center>Points (App Transaction)</center>  </th>
                                    </tr>
                                    <tr>
                                        <td> -999 </td>
                                        <td> 2 </td>
                                        <td> 5 </td>
                                    </tr>
                                    <tr>
                                        <td>  3 </td>
                                        <td> 30 </td>
                                         <td> 3 </td>
                                    </tr>
                                    <tr>
                                        <td>  31 </td>
                                        <td> 45 </td>
                                        <td> 1 </td>
                                    </tr>
                                    <tr>
                                        <td> 46 </td>
                                        <td> 65 </td>
                                         <td> 0 </td>
                                    </tr>
                                    <tr>
                                        <td> 66 </td>
                                         <td> 90 </td>
                                         <td> -2 </td>
                                    </tr>
                                    <tr>
                                        <td> 91 </td>
                                        <td> 120 </td>
                                        <td> -4 </td>
                                    </tr>
                                    <tr>
                                        <td> 121 </td>
                                        <td> 999 </td>
                                        <td> -4 </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
               </div>
         </div> 
      </>  
   ) 
}
export default LoyaltyTerms;